export const createCamerasObject = (cameras: any) => {
  const returnObject: any = {};
  cameras.map((object: any) => {
    returnObject[object.id] = {
      camera: object.camera ? true : false,
      id: object.id,
      products: [],
      immix: {},
      dice: {},
      sureview: {},
      sentinel: {},
      // softguard: {},
      sysaid: {},
      bold: {},
      patriot: {},
      evalink: {},
      // The NVR device id/guid is returned as `nvr_id` by the serializer;
      // fall back to it so the device id is populated (older code read the
      // non-existent `device_id` field, leaving this blank).
      device_id: object.device_id || object.nvr_id || "",
    };
  });
  return returnObject;
};
